import { StrictLocalMsg } from "@faire/web/ui/lib/localization";

const OpenWithFaireApplicationButtonText: React.FC = () => {
  return (
    <StrictLocalMsg
      id="whPQ6M"
      defaultMessage="Complete application"
      description={{
        text: "Button caption leading to the Open with Faire application form for retailer to submit their information",
        img: "https://cdn.faire.com/fastly/11339aefccae204698918abe16f3b87a4cd9f842532bf20395c4dca832968163.png",
      }}
    />
  );
};

export default OpenWithFaireApplicationButtonText;
